import React from 'react';
import Button from 'jbc-front/components/Button';
import { useMutation } from '../components/Graphql';
import { gql } from '@apollo/client';
import { Panel, Headding, Item, Lead, Notes, Buttons } from '../components/PrimaryPanel';
import useReactRouter from 'use-react-router';
import { CustomDescription } from '../components/QuestionDescription';
import styles from './Start.scss';

const ANSWER_START = gql`
  mutation answerStart {
    answerStart(input: { start: true }) {
      questions {
        id
        status
      }
    }
  }
`;

const Question = ({ dispatch }) => {
  const [answer, { loading }] = useMutation(ANSWER_START);
  const { history } = useReactRouter();
  return (
    <Panel>
      <Headding className={styles.primaryPanelHeader}>年末調整開始</Headding>
      <Item>
        <Lead>年末調整を始める前に</Lead>
        <CustomDescription field="top" />
        <Buttons>
          <Button
            huge
            secondary
            onClick={async () => {
              await answer();
              history.push('/employee_input');
            }}
            disabled={loading}
          >
            年末調整を始める
          </Button>
        </Buttons>
      </Item>
    </Panel>
  );
};

export default Question;
